// 根据环境切换 API 地址
if (process.env.NODE_ENV !== 'production') {
  // 开发环境
  module.exports = {
    apiURL: '/' // 开发环境用相对路径，通过 vue proxy 代理
  }
} else {
  // 生产环境
  module.exports = {
    apiURL: 'https://homeapi.xingxiwang.com'
  }
}
